export type RepeatMode = 'off' | 'one' | 'all';

export function parsePlayMode(mode?: string | null): { shuffle: boolean; repeat: RepeatMode } {
  switch ((mode || 'NORMAL').toUpperCase()) {
    case 'SHUFFLE_NOREPEAT':
      return { shuffle: true, repeat: 'off' };
    case 'SHUFFLE':
      return { shuffle: true, repeat: 'all' };
    case 'SHUFFLE_REPEAT_ONE':
      return { shuffle: true, repeat: 'one' };
    case 'REPEAT_ALL':
      return { shuffle: false, repeat: 'all' };
    case 'REPEAT_ONE':
      return { shuffle: false, repeat: 'one' };
    default:
      return { shuffle: false, repeat: 'off' };
  }
}

export function nextRepeatMode(current: RepeatMode): RepeatMode {
  if (current === 'off') return 'one';
  if (current === 'one') return 'all';
  return 'off';
}
